import mutations from './mutations'
import actions from './actions'
import getters from './getters'
const state = {
  greetings: localStorage.getItem('messages') && JSON.parse(localStorage.getItem('messages'))  || [],
};

const module = {
  state,
  getters,
  mutations,
  actions
};

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/messages/index.js